<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col md="4" sm="6">
          Agendado em: <strong>{{ _.get(task, 'created_at_formatted') }}</strong>
        </v-col>
        <v-col md="4" sm="6">
          Data da execução: <strong>{{ _.get(task, 'date_formatted') }}</strong>
        </v-col>
        <v-col md="4" sm="6">
          Agendado por: <strong>{{  _.get(task, 'user.name') }}</strong>
        </v-col>
        <v-col md="4" sm="6">
          Status: <strong>{{ _.get(task, 'status_formatted') }}</strong>
        </v-col>
        <v-col md="4" sm="6">
          Atualização em massa: <strong>{{ _.get(task, 'bulk') ? 'Sim' : 'Não' }}</strong>
        </v-col>
        <v-col md="4" sm="6">
          Tipo: <strong>{{ _.get(task, 'type_formatted') }}</strong>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn text color="primary" @click="$router.push('/task/'+task.id)">
        Ver mais detalhes
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'CardTask',
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  computed: {
    _() {
      return _
    },
  }
}
</script>

<style scoped>

</style>